/**
 * 実行
 */

import { listen, prefetch } from "quicklink";
require('intersection-observer');
import isn from './intersection.js';
import fun from './functions.js';
import smoothscroll from "smoothscroll-polyfill";
// import Swiper from "swiper";

(function() {
  "use strict";

  document.body.classList.add("js-validity");

  isn.DataElementHide("[data-element_hide]");
  isn.DataScroll("[data-scroll]");
  isn.DataSrc("[data-src]");
  isn.DataBack("[data-back]");
  smoothscroll.polyfill();
  fun.SmoothLink();

  const data_click = document.querySelectorAll("[data-click]");
  for (let i = 0, len = data_click.length; i < len; ++i) {
    data_click[i].addEventListener("click", e => {
      const click = data_click[i].dataset.click;
      switch (click) {
        case "menu":
          fun.ClickMenu();
          break;
        case "toggle":
         fun.ClickToggle(data_click[i]);
          break;
        case "go_top":
          fun.ClickGoTop();
          break;
      }
    });
  }

  const data_tab = document.querySelectorAll("[data-tab] > li");
  for (let i = 0, len = data_tab.length; i < len; ++i) {
    data_tab[i].addEventListener("click", e => {
      fun.ClickTab(data_tab, data_tab[i]);
    });
  }

  const data_modal = document.querySelectorAll("[data-modal]");
  for (let i = 0, len = data_modal.length; i < len; ++i) {
    data_modal[i].addEventListener("click", e => {
      fun.ClickModal(data_modal, data_modal[i]);
    });
  }

  const targetblank_flag_val = document.body.dataset.targetblank_flag;
  if (targetblank_flag_val == true) {
    fun.TargetBlank();
  }

  window.addEventListener('DOMContentLoaded', () =>{
  });

  window.addEventListener('load', () =>{
    const quicklink_flag_val = document.body.dataset.quicklink_flag;
    if (quicklink_flag_val == true) {
      listen({
        ignores: [
          /\/wp-admin\/?/,
          /\/wp-login\/?/,
          /\/contact\/?/,
          /\/booking\/?/,
          uri => uri.includes("#"),
          (uri, elem) => elem.hasAttribute("noprefetch")
          // or RegExp: /#(.+)/
          // or element matching: (uri, elem) => !!elem.hash
        ]
      });
    }
  });
})();
